import React, { useState } from 'react';
import { Link} from 'react-router-dom';

export const EyePower = () => {
  const [addcart, setaddcart] = useState(false);
  const [counter, setCounter] = useState(1);
  const incrementCount = () => {
    setCounter(counter + 1);
  };
  const decrementCount = () => {
    setCounter((c) => Math.max(c - 1, 1));
  };

  return (
    <>
      <div className="lg:w-3/4 w-full mb-2 mx-auto power-type-modal">
        <div className="h-full flex items-center align-middle justify-center overflow-y-auto less240">
          <div>
            <div className="border md:p-5 lg:mt-0 mt-14 p-2 rounded">
              <h2 className="text-center lg:text-2xl font-medium">What About My Eye Power?</h2>
              <div className="lg:px-10 px-4">
                <p className="my-3"><img src="images/right-icon.png" alt="Check" className="w-8 inline-block mr-2" /> You can submit your eye power after Payment step</p>
                <div className="flex justify-between font-light my-5">
                  <div>
                    <i className="fa fa-phone"></i> Phone Assistance
                  </div>
                  <div>
                    <i class="fa fa-file-image-o"></i> Upload Prescription
                  </div>
                </div>
                <hr />
                <p className="my-3"><img src="images/right-icon.png" alt="Check" className="w-8 inline-block mr-2 mt-4" /> Power can be submitted within 10 days of order placement</p>
                <p className="my-3"><img src="images/right-icon.png" alt="Check" className="w-8 inline-block mr-2" /> No additional charges for high/complex power</p>
              </div>
            </div>
            <span className="text-cyan-500 text-sm text-center block mt-3 mb-4">I have read and understood the terms of power submission</span>
            <hr className="my-4" />
          </div>
        </div>
        <div className="flex justify-between py-2">
          <div className="grid place-content-center"><div>Subtotal <span className="text-gray-400">(Frame + Lens):</span> <span className="text-cyan-500">$98</span></div></div>
          <div><button onClick={() => setaddcart((prevState) => !prevState)} className="bg-cyan-500 text-white uppercase rounded py-2 lg:px-14 px-5">I Agree</button></div>
        </div>
      </div>

      {/* add to cart */}
      <div className={addcart === true ? "fixed add_to_cart right-0 bg-white lg:w-1/3 z-[9999] top-0 h-screen px-5 py-7 overflow-y-auto shadow-xl" : "fixed add_to_cart -right-[114%] bg-white lg:w-1/3 z-[9999] top-0 h-screen px-5 py-7 overflow-y-auto shadow-xl"}>
        <span className="absolute right-2 font-bold cursor-pointer top-1 text-xl text-gray-500 hover:text-gray-700" onClick={() => setaddcart((prevState) => !prevState)}>x</span>
        <div className="mt-4">
          <h4>Silver Blue Full Rim Square Vincent Chase</h4>
          <div className="flex mt-8 gap-4 justify-center items-center">
            <div><img src="images/product-01.png" alt="product" className="w-60" /></div>
            <div className="">
              <button type="button" className="bg-gray-300 w-10 h-8 rounded-l" onClick={decrementCount} > - </button>
              <input type="number" min="1" value={counter} className="h-8 w-10 border relative top-[1px]" />
              <button type="button" className="bg-gray-300 w-10 h-8 rounded-r" onClick={incrementCount} > + </button>
            </div>
          </div>
        </div>

        <table class="mt-8 text-left w-full text-sm leading-loose text-gray-500 border-spacing-2 border">
          <tbody>
            <tr>
              <td className="border border-slate-200 p-1">FRAME PRICE</td>
              <td className="border border-slate-200 p-1">$98</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1">LENS PACKAGE</td>
              <td className="border border-slate-200 p-1">Thin Anti-Glare_sg $0</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1">SUBTOTAL</td>
              <td className="border border-slate-200 p-1">$98</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1">Net Amount</td>
              <td className="border border-slate-200 p-1">$98</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1">Convenience Fees</td>
              <td className="border border-slate-200 p-1">Free</td>
            </tr>
            <tr>
              <td className="border border-slate-200 p-1 bg-gray-100">Order Total</td>
              <td className="border border-slate-200 p-1 bg-gray-100">$98</td>
            </tr>
          </tbody>
        </table>
        <Link to="/checkout" class="bg-cyan-500 text-white w-full mt-6 rounded p-2 tracking-wider block text-center">
          <span class="uppercase text-sm font-light">Proceed to Checkout</span>
          <span class="block text-xs font-light">(You can submit your power at the end)</span>
        </Link>
      </div>
    </>
  )
}